import { DayOfWeek } from '../../enums/DayOfWeek';
import { EmployeePositionId } from '../employee/Employee';

/**
 * A class that describes an employee being absent half day in the rota.
 */
export class RotaHalfDayAbsenceAssignment {
  employeePositionId: EmployeePositionId;
  dayOfWeek: DayOfWeek;
  startTime: string;
  endTime: string;

  /**
   * @param employeePositionId the identifier of the employee and position.
   * @param dayOfWeek the day of week of the assignment.
   * @param startTime start time of the absence.
   * @param endTime end time of the absence.
   */
  constructor(
    employeePositionId: EmployeePositionId,
    dayOfWeek: DayOfWeek,
    startTime: string,
    endTime: string
  ) {
    this.employeePositionId = employeePositionId;
    this.dayOfWeek = dayOfWeek;
    this.startTime = startTime;
    this.endTime = endTime;
  }

  hasEqualEmployeeAndDay(employeePositionId: EmployeePositionId, dayOfWeek: DayOfWeek): boolean {
    return this.employeePositionId.value === employeePositionId.value && this.dayOfWeek === dayOfWeek;
  }
}
